class DragScroll {
    constructor(selector) {

        this.elements = typeof selector === 'string' 
            ? document.querySelectorAll(selector)
            : [selector];
        
        if (this.elements.length > 0) {
            this.init();
        }
    }

    init() {
        this.elements.forEach(element => {
            this.initElement(element);
        });
    }

    initElement(element) {

        let isDragging = false;
        let startX;
        let scrollLeft;

        // Mouse events
        element.addEventListener('mousedown', (e) => {
            isDragging = true;
            element.classList.add('dragging');
            startX = e.pageX - element.offsetLeft;
            scrollLeft = element.scrollLeft;
        });

        element.addEventListener('mouseleave', () => {
            isDragging = false;
            element.classList.remove('dragging');
        });

        element.addEventListener('mouseup', () => {
            isDragging = false;
            element.classList.remove('dragging');
        });

        element.addEventListener('mousemove', (e) => {
            if (!isDragging) return;
            e.preventDefault();
            const x = e.pageX - element.offsetLeft;
            const walk = (x - startX) * 2;
            element.scrollLeft = scrollLeft - walk;
        });

        // Touch events
        element.addEventListener('touchstart', (e) => {
            isDragging = true;
            element.classList.add('dragging');
            startX = e.touches[0].pageX - element.offsetLeft;
            scrollLeft = element.scrollLeft;
        });

        element.addEventListener('touchend', () => {
            isDragging = false;
            element.classList.remove('dragging');
        });

        element.addEventListener('touchmove', (e) => {
            if (!isDragging) return;
            e.preventDefault();
            const x = e.touches[0].pageX - element.offsetLeft;
            const walk = (x - startX) * 2;
            element.scrollLeft = scrollLeft - walk;
        });
    }
}

export default DragScroll;
